import React, { useContext } from 'react';
import { MapControlContext } from 'views/MapPage/contexts/mapcontrol.context';
import { SearchFilterContext } from 'views/MapPage/contexts/searchFilter.context';
import { SearchBarContainerStyled } from 'views/MapPage/Styled';
import { MobileSearchBarStyled, StyledMobileMapFilterPanel } from './mobileStyles';
import { StyledInputContainer } from 'components/AsyncSelect/Styled';
import Button from 'components/Button/Button';
import MobileAsyncSelectSearch from './MobileAsyncSelectSearch';
import NoSearchResultsPanel from '../NoSearchResultsPanel';
import useDevice from 'hooks/useDevice';
import MobileAssetsPeopleCheckBoxGroup from './MobileAssetsPeopleCheckBoxGroup';
import useMobileFilterPanel from 'views/MapPage/hooks/useMobileFilterPanel';

import MobileDropdownFilterInputController from 'views/MapPage/components/SearchFilterBar/MobileDropdownFilterInputController';
import NoFilterResultsPanel from '../NoFilterResultsPanel';

export default function MobileMapSearchFilterPanel({
  setMobileMapFilterMenuOpen,
  mobileMapFilterMenuOpen,
}: {
  setMobileMapFilterMenuOpen: (arg: boolean) => void;
  mobileMapFilterMenuOpen: boolean;
}) {
  const { isMobileDevice } = useDevice();
  const { apiCallInProgress } = useContext(MapControlContext);

  const {
    handleClosePanel,
    handleMobileSearchFilters,
    setAssetUserCheckboxArray,
    assetUserCheckboxArray,
    noSearchResultsReturned,
    noFilterResultsReturned,
    resetSearchFromCheckbox,
  } = useMobileFilterPanel({ setMobileMapFilterMenuOpen });

  const { searchTerm, searchType } = useContext(SearchFilterContext);

  function handleInputClick(ev: React.SyntheticEvent) {
    const target = ev.target as HTMLTextAreaElement;
    const targetClassName = target.classList[0];
    // prevent anything occuring if input was not clicked.
    if (targetClassName !== 'asyncSearchPrefix__input') return;
  }

  return (
    <StyledMobileMapFilterPanel
      title="Search & Filter"
      from="left"
      isOpen={mobileMapFilterMenuOpen}
      onRequestClose={() => {
        handleClosePanel();
      }}
    >
      <SearchBarContainerStyled>
        <p style={{ marginBottom: '10px' }} className="searchbar-readout">
          Search
        </p>
        <MobileSearchBarStyled>
          <StyledInputContainer
            width={'100%'}
            onClick={(ev: React.SyntheticEvent) => handleInputClick(ev)}
          >
            <MobileAsyncSelectSearch handleMobileSearchFilters={handleMobileSearchFilters} />
            {noSearchResultsReturned && (
              <NoSearchResultsPanel searchType={searchType} searchTerm={searchTerm} />
            )}
          </StyledInputContainer>
        </MobileSearchBarStyled>

        {!isMobileDevice && (
          <SearchBarContainerStyled>
            <p style={{ marginBottom: '10px' }} className="searchbar-readout">
              Show
            </p>
            <MobileSearchBarStyled>
              <MobileAssetsPeopleCheckBoxGroup
                assetUserCheckboxArray={assetUserCheckboxArray}
                setAssetUserCheckboxArray={setAssetUserCheckboxArray}
              />
            </MobileSearchBarStyled>
          </SearchBarContainerStyled>
        )}

        <MobileDropdownFilterInputController resetSearchFromCheckbox={resetSearchFromCheckbox} />
        {noFilterResultsReturned && <NoFilterResultsPanel />}
      </SearchBarContainerStyled>
      <Button
        isLoading={apiCallInProgress && apiCallInProgress}
        onClick={handleMobileSearchFilters}
      >
        Done
      </Button>
    </StyledMobileMapFilterPanel>
  );
}
